import {GenericList} from './GenericList';
import {Invoice} from "../../models/Invoice";

export class InvoiceList extends GenericList<Invoice> {}
